export const pushAddressInputFocus = () => {
  window.dataLayer.push({
    event: 'GA_event',
    eventCategory: 'inputFieldClick',
    eventAction: 'Адрес доставки сим',
  });
};
